import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-operationlog",
  "use": "icon-operationlog-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-operationlog\"><defs><style>#icon-operationlog .cls-1{fill:none;}</style></defs><title> </title><rect class=\"cls-1\" x=\"140.01\" y=\"449\" width=\"744\" height=\"122\" /><rect x=\"706.66\" y=\"-0.17\" width=\"120.5\" height=\"159\" /><path d=\"M879.3,124V262H650.64V124H375.33V262H146.66V124H0v900H1024V124ZM884,841H140V719H884Zm0-270H140V449H884Z\" /><rect x=\"199.66\" y=\"-0.17\" width=\"120.5\" height=\"159\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/operationlog.svg
// module id = uCGJ
// module chunks = 54